// import "solid-devtools";
// import { setElementInterface } from "solid-devtools/setup";
// import { elementInterface } from "@solidtv/solid/devtools";

// setElementInterface(elementInterface);

// Patch Object.getOwnPropertyNames to prevent strict mode errors in solid-js mergeProps
(function() {
  const originalGetOwnPropertyNames = Object.getOwnPropertyNames;
  Object.getOwnPropertyNames = function(obj) {
    const names = originalGetOwnPropertyNames(obj);
    if (obj && (typeof obj === 'function' || Object.prototype.toString.call(obj) === '[object Arguments]')) {
      return names.filter(function(name) {
        return name !== 'caller' && name !== 'callee' && name !== 'arguments';
      });
    }
    return names;
  };
})();


import { createRenderer, Config, loadFonts } from "@solidtv/solid";
//import { WebGlCoreRenderer, SdfTextRenderer } from "@solidtv/renderer/webgl";
//import { CanvasCoreRenderer, CanvasTextRenderer } from "@solidtv/renderer/canvas";
import type { RendererMain } from "@solidtv/renderer";
import {
  Rounded,
  RoundedWithShadow,
  RoundedWithBorder,
  RoundedWithBorderAndShadow,
  RadialGradient,
  LinearGradient,
  HolePunch
} from "@solidtv/renderer/shaders";

window.bundleType = import.meta.env.LEGACY ? "LEGACY (nomodule)" : "MODERN (module)";
console.log(`[bundle] Loaded ${window.bundleType} build`);

// (Wake-Up code moved down to where renderer is defined)

import { FocusStackProvider, lazy } from "@solidtv/solid/primitives";
import { HashRouter, KeepAliveRoute } from "@solidtv/solid/primitives/router";
import { Route, Navigate } from "@solidjs/router";
import App from "./pages/App";
import Home from "./pages/Home";
import NotFound from "./pages/NotFound";
import fonts from "./fonts";
import LeftNavWrapper from "./pages/LeftNavWrapper";
import theme from "theme";

const LiveStream = lazy(() => import("./pages/LiveStream"));

let numImageWorkers = 1;
const urlParams = new URLSearchParams(window.location.search);
const numWorkers = urlParams.get("numImageWorkers");
const screenSize = urlParams.get("size") || "default";
const animationsEnabled = urlParams.get("animate") || "true";
// Off by default — enable with ?contextSpy=true to capture per-frame WebGL call counts
const enableContextSpy = urlParams.get("contextSpy") === "true";
// Off by default (renderer requests a WebGL1 context) — force WebGL2 with ?webgl2=true
const forceWebGL2 = urlParams.get("webgl2") === "true";
//get screen size from @solidtv/renderer

if (numWorkers) {
  numImageWorkers = parseInt(numWorkers);
}
console.log("screenSize", screenSize);
const deviceLogicalPixelRatio = {
  "720": 0.666667,
  medium: 0.8,
  "1080": 1,
  "4k": 2,

  default: window.innerHeight / 1080
}[screenSize];
console.log("deviceLogicalPixelRatio", deviceLogicalPixelRatio, screenSize);
const logFps = false;
Config.debug = false;
// Config.keyDebug = true;
Config.animationsEnabled = animationsEnabled === "true";
Config.fontSettings.fontFamily = "Roboto";
Config.fontSettings.color = theme.textPrimary;
Config.fontSettings.fontSize = 32;
Config.domRendererEnabled = false;

// Config.focusDebug = true;

Config.rendererOptions = {
  appWidth: window.innerWidth / (deviceLogicalPixelRatio || 1),
  appHeight: 1080,
  fpsUpdateInterval: logFps ? 1000 : 0,
  textureMemory: {
    criticalThreshold: 200e6,
    targetThresholdLevel: 0.75,
    cleanupInterval: 5000,
    doNotExceedCriticalThreshold: false
  },
  numImageWorkers,
  imageDecodeConcurrency: 6,
  textLayoutCacheSize: 100,
  idleTextLayouts: 0,
  deviceLogicalPixelRatio,
  devicePhysicalPixelRatio: 1,
  createImageBitmapSupport: "auto",
  boundsMargin: 100,
  targetFPS: 0,
  presentOnIdle: true,
  enableContextSpy,
  forceWebGL2
};


// Delay initialization to allow the browser to perform a first paint of the splash screen
requestAnimationFrame(() => {
  setTimeout(() => {
    const { renderer, render } = createRenderer();

    // FIX: WebGL Canvas Sleep Bug on TV Resume
    document.addEventListener("visibilitychange", () => {
      if (!document.hidden) {
        setTimeout(() => {
          try {
            if (renderer && renderer.requestRender) {
              renderer.requestRender();
            }
          } catch(e) { console.error("Wake error", e); }
        }, 50);
      }
    });

    let idleFired = false;
    const hideSplash = () => {
      if (!idleFired) {
        idleFired = true;
        const splash = document.getElementById('splash');
        if (splash) {
          splash.classList.add('fade-out');
          setTimeout(() => {
            splash.remove();
          }, 500);
        }
      }
    };

    renderer.on('idle', hideSplash);

    // Failsafe: ALWAYS hide the splash screen after 5 seconds, even if the renderer is still loading textures/fonts!
    // This prevents the app from hanging forever on older LG TVs if a network request for an image stalls.
    setTimeout(hideSplash, 5000);
loadFonts(fonts);
// Prepare for RC3 of Renderer
const shaders = renderer as RendererMain;
shaders.registerShaderType("rounded", Rounded);
shaders.registerShaderType("roundedWithBorder", RoundedWithBorder);
shaders.registerShaderType("roundedWithShadow", RoundedWithShadow);
shaders.registerShaderType("roundedWithBorderWithShadow", RoundedWithBorderAndShadow);
shaders.registerShaderType("radialGradient", RadialGradient);
shaders.registerShaderType("linearGradient", LinearGradient);
shaders.registerShaderType("holePunch", HolePunch);
render(() => (
  <FocusStackProvider>
    <HashRouter root={(props) => <App {...props} />}>
      <Route path="" component={LeftNavWrapper}>
        <Route path="" component={() => <Navigate href="/home" />} />
        <KeepAliveRoute id="home" path="home" component={Home} />
        <Route path="live" component={LiveStream} />
        <Route path="*all" component={NotFound} />
      </Route>
    </HashRouter>
  </FocusStackProvider>
));
  }, 0);
});

